// React imports.
import React from "react";


// App imports.
import Assessment2bMainTableRow from "./Assessment2bMainTableRow";

const Assessment2bMainTable = ({ state, step, holder, fieldChangeHandler }) => (
    <div>
        <br />
        <div className="vendorsReportedGrid">
            <div className="header">Main Heating Fuel</div>
            <div className="header">Total # of Assisted Households</div>
            <div className="header"># of Households for Whom Electric Data was Received</div>
            {step.showDataReceivedStatus === true &&
                <React.Fragment>
                    <div className="header">% of HHs for Whom Electric Data was Received</div>
                    <div className="header">Status</div>
                </React.Fragment>
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.Electric.name)
                &&
                <Assessment2bMainTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.Electric.name )} fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.Electric} />
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.NaturalGas.name)
                &&
                <Assessment2bMainTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.NaturalGas.name )} fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.NaturalGas} />
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.FuelOil.name)
                &&
                <Assessment2bMainTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.FuelOil.name )} fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.FuelOil} />
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.Propane.name)
                &&
                <Assessment2bMainTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.Propane.name )}fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.Propane} />
            }
        </div>
    </div>
);

export default Assessment2bMainTable;
